import type { Merger, MergerArgs } from '#src/merge/mergers/merger.ts'

export const conditionClinicalStatusMerger: Merger = {
  canMerge: (args: MergerArgs): boolean =>
    args.key === 'clinicalStatus' &&
    args.current !== undefined &&
    args.incoming !== undefined,
  merge: (args: MergerArgs) => args.incoming,
}
